/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Intro_Step_2_DescInputs */

const es_home_intro_step_2_desc = /** @type {(inputs: Home_Intro_Step_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La IA procesa y organiza automáticamente tus documentos, emails y eventos.`)
};

const en_home_intro_step_2_desc = /** @type {(inputs: Home_Intro_Step_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI automatically processes and organizes your documents, emails, and events.`)
};

/**
* | output |
* | --- |
* | "AI automatically processes and organizes your documents, emails, and events." |
*
* @param {Home_Intro_Step_2_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_intro_step_2_desc = /** @type {((inputs?: Home_Intro_Step_2_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Intro_Step_2_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_intro_step_2_desc(inputs)
	return en_home_intro_step_2_desc(inputs)
});
export { home_intro_step_2_desc as "home.intro.step_2_desc" }